import { s, typographyTokens } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import { InfoOutlinedIcon } from '@/ui/primitives/icons';
import { MetricInfoPopoverButton } from './MetricInfoPopoverButton';
import type { ReactElement, ReactNode } from 'react';

type MetricCardTitleProps = {
  children: ReactNode;
  fontSize?: string | { xs?: number; xl?: number };
  infoContent?: ReactNode;
  showInfoIcon?: boolean;
};

export const MetricCardTitle = ({
  children,
  fontSize = typographyTokens.body.fontSize,
  infoContent,
  showInfoIcon = false,
}: MetricCardTitleProps): ReactElement => (
  <Box
    sx={{
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
      gap: s('sm'),
      color: (theme) => theme.app.colors.textMuted,
      fontSize,
      fontWeight: typographyTokens.body.fontWeight,
      lineHeight: 1.25,
      whiteSpace: 'nowrap',
    }}
  >
    <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {children}
    </Box>
    {showInfoIcon && infoContent ? (
      <MetricInfoPopoverButton
        ariaLabel={`About ${
          typeof children === 'string' || typeof children === 'number' ? String(children) : 'metric'
        }`}
      >
        {infoContent}
      </MetricInfoPopoverButton>
    ) : showInfoIcon ? (
      <InfoOutlinedIcon
        sx={{
          flexShrink: 0,
          fontSize: 15,
          color: 'inherit',
          transform: 'translateY(-1px)',
        }}
      />
    ) : null}
  </Box>
);
